import Breadcrumb from 'components/Navigation/Breadcrumb';
import React, { useState } from 'react';
import male from '../../../../../assets/male-big.png';
import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import { useParams } from 'react-router-dom';
import { useGetExecutor } from 'common/queries-and-mutations/executor';
import { Loader } from 'components/Loader';
import EditExecutorsModal from './EditExecutorsModal';
import { BeneficiaryTypeEnum } from 'apps/user/types/user.enum.type';
import { format } from 'date-fns';

export default function ExecutorsProfile() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [userId, setUserId] = useState<number | null | undefined>(null);

  const { executorId } = useParams();

  const { data, isLoading, refetch } = useGetExecutor({
    executorId: Number(executorId)
  });

  return (
    <div>
      {isLoading && data ? (
        <div className="mt-40 flex flex-col items-center justify-center">
          <Loader color={'#FF6606'} height={50} width={50} />
        </div>
      ) : (
        <>
          <Breadcrumb title="Executor Profile" />
          <div className="mt-1">
            <div className="mb-5 flex flex-row rounded bg-white">
              <div className="flex w-1/5 flex-col items-center justify-center border-r px-6">
                <div className="flex flex-col items-center justify-center gap-3">
                  <img src={male} />
                  <p className="text-xl font-bold text-[#353535]">
                    {`${data?.executorFirstName} ${data?.executorMiddleName} ${data?.executorLastName}`}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="border-b border-[#E5E5E5]">
                  <div className="mt-3 grid grid-cols-4 gap-x-16 px-6">
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Name
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {`${data?.executorFirstName} ${data?.executorMiddleName} ${data?.executorLastName}`}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Email address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.emailAddress}
                      </p>
                    </div>
                    <div className="col-span-1 px-8 py-6">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Type
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.executorType}
                      </p>
                    </div>
                    {data?.executorType === BeneficiaryTypeEnum.INDIVIDUAL ? (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Phone Number
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.phoneNumber}
                        </p>
                      </div>
                    ) : (
                      <div className="col-span-1 px-8 py-6">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          RC Number
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.rcNumber}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-b border-[#E5E5E5]">
                  <div className="grid grid-cols-4 gap-x-16 px-6">
                    <div className="col-span-1 px-8 py-4">
                      <p className="text-[10px] font-normal text-[#7A7C87]">
                        Address
                      </p>
                      <p className="mt-1 text-sm font-normal text-[#353535]">
                        {data?.address}
                      </p>
                    </div>
                    {data?.executorType === BeneficiaryTypeEnum.INDIVIDUAL ? (
                      <div className="col-span-1 px-8 py-4">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Relationship
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.relationship}
                        </p>
                      </div>
                    ) : (
                      <div className="col-span-1 px-8 py-4">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Incorporation Place
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.incorporationPlace}
                        </p>
                      </div>
                    )}

                    {data?.executorType === BeneficiaryTypeEnum.CORPORATE && (
                      <div className="col-span-1 px-8 py-4">
                        <p className="text-[10px] font-normal text-[#7A7C87]">
                          Incorporation Date
                        </p>
                        <p className="mt-1 text-sm font-normal text-[#353535]">
                          {data?.incorporationDate
                            ? format(
                                new Date(data.incorporationDate),
                                'dd MMMM yyyy'
                              )
                            : 'Unknown'}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-4 gap-x-16 px-6">
                  <div className="col-span-1 px-8 py-4">
                    <Button
                      variant="outline"
                      size="md"
                      className="w-[15rem] rounded border border-[#FF7A00] bg-[#FFF8F2] p-[0.1rem] text-[#FF7A00]"
                      label="Edit Executor"
                      icon={<Icon name={Icons.Edit} />}
                      onClick={() => {
                        setUserId(data?.id);
                        setShowEditModal(true);
                      }}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showEditModal && userId && (
        <EditExecutorsModal
          onClose={() => {
            setShowEditModal(false);
            refetch();
          }}
          onSuccess={() => {
            refetch();
            setShowEditModal(false);
            setUserId(null);
          }}
          executorId={userId}
        />
      )}
    </div>
  );
}
